import React, { useEffect, useState, useRef } from 'react';
import { useMediaQuery } from "@mui/material";
import "./Footer.css";

import Copyright from "../images/vimsionlogo.png";
import InstagramLogo from "../images/instagram128.png";
import LinkedinLogo from "../images/linkedin128.png";
import FacebookLogo from "../images/facebook.png";

import PlayCircleOutlineIcon from "@mui/icons-material/PlayCircleOutline";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import YouTubeIcon from "@mui/icons-material/YouTube";
import EmailOutlinedIcon from "@mui/icons-material/EmailOutlined";


import { useLanguage } from "../context/LanguageContext.js";


const Footer = ({ onHeightChange, headerHeight }) => {
  const { t, lang } = useLanguage();
  const supportedVideos = ["fr", "en", "es"];
  const videoSrc = supportedVideos.includes(lang)
    ? `/organizwk-demo-${lang}.mov`
    : "/organizwk-demo-fr.mov";

  const footerRef = useRef(null);
  const isMobile = useMediaQuery("(max-width:600px)");
  const [localHeaderHeight, setLocalHeaderHeight] = useState(0);
  const [showVideo, setShowVideo] = useState(false);
  const [emailCopie, setEmailCopie] = useState(false);


  useEffect(() => {
  const header = document.querySelector('.header');
    if (header) {
      const updateHeight = () => setLocalHeaderHeight(header.offsetHeight);
      updateHeight();
      window.addEventListener('resize', updateHeight);
        return () => window.removeEventListener('resize', updateHeight);
    }
  }, []);

  useEffect(() => {
    const updateHeight = () => {
      if (footerRef.current && typeof onHeightChange === "function") {
        onHeightChange(footerRef.current.offsetHeight);
      }
    };
    updateHeight();
    window.addEventListener("resize", updateHeight);
    return () => window.removeEventListener("resize", updateHeight);
  }, [onHeightChange]);

  return (
    <footer 
    ref={footerRef}  
    className="footer"
    style={{
      width: "100%",
      backgroundColor: "#f4ece2",
      padding: "2px",
      boxShadow: "0 2px 8px rgba(0,0,0,0.2)",
      zIndex: 1300,
      ...(isMobile
        ? {
          position: "fixed",
          top: `${localHeaderHeight}px`,

          left: 0,
          right: 0,
        }
      : {
        position: "fixed",
        bottom: 0 
      }),
    }}
  >
  
  {/* Logo Instagram à gauche */}
    <a
      href="https://www.instagram.com/organizwk"
      target="_blank"
      rel="noopener noreferrer"
      title="Instagram"
      >
      <img
        src={InstagramLogo}
        alt="Instagram"
        className="footer-icon"
      />
    </a>


    {/* Logo LinkedIn à droite */}
      <a
        href="https://www.linkedin.com/showcase/organizwk"
        target="_blank"
        rel="noopener noreferrer"
        title="LinkedIn"
      >
        <img
          src={LinkedinLogo}
          alt="LinkedIn"
          className="footer-icon"
        />
      </a>

    {/* Logo Facebook */}
      <a
        href="https://www.facebook.com/profile.php?id=61586788287196"
        target="_blank"
        rel="noopener noreferrer"
        title="Facebook"
      >
      <img
        src={FacebookLogo}
        alt="Facebook"
        className="footer-icon"
      />
      </a>

      {/* Image centrale */}
      <a
        href="https://www.linkedin.com/company/vimsion"
        target="_blank"
        rel="noopener noreferrer"
        title="Vimsion"
        >
        <img
          src={Copyright}
          alt="Mentions légales"
          className="footer-text-image"
          style={{ 
          cursor: "pointer",
          height: "26px",
          width: "auto"
        }}
      />
      </a>

    {/* Icône vidéo démo */}
    <IconButton
      onClick={() => setShowVideo(true)}
      title={t("SeeDemo")}
      sx={{ padding: 0, marginLeft: "2px" }}
    >
      <PlayCircleOutlineIcon sx={{ fontSize: 28, color: "#3b5998" }} />
    </IconButton>

        <Dialog 
        open={showVideo} 
        onClose={() => setShowVideo(false)} 
        maxWidth="xs" 
        PaperProps={{ 
          sx: { 
            borderRadius: "12px", 
            padding: "8px",
            width: "90%",
            maxWidth: "360px",
            margin: "0 auto"
            } 
            }}
        >
          <DialogTitle>
            {t("DemoVideo")}
            <IconButton
              onClick={() => setShowVideo(false)}
              sx={{ position: "absolute", right: 8, top: 8 }}
            >
              <CloseIcon />
            </IconButton>
          </DialogTitle>

          <DialogContent>
          <video
            src={videoSrc}
            controls
            playsInline 
            webkit-playsinline="true"
            style={{ 
              width: "100%", 
              borderRadius: "8px",
              maxHeight: "300px", 
              objectFit: "contain" 
            }}
          />
        </DialogContent>
      </Dialog>

      <a
        href="https://www.youtube.com/@organizwk"
        target="_blank"
        rel="noopener noreferrer"
        title="YouTube"
      >
        <YouTubeIcon sx={{ fontSize: 26, color: "#FF0000", marginLeft: "4px" }} />
      </a>

      <IconButton
        onClick={async () => {
          try {
            await navigator.clipboard.writeText("organizwk@gmail.com");

            setEmailCopie(true);

            setTimeout(() => {
              setEmailCopie(false);
            }, 2000);
          } catch (err) {
            console.error("Impossible de copier l'adresse e-mail", err);
          }
        }}
          title={t("CopyEmailAddress")}
          sx={{ padding: 0, marginLeft: "4px" }}
        >
          <EmailOutlinedIcon sx={{ fontSize: 26, color: "#555" }} />
      </IconButton>

    {emailCopie && (
      <span
        style={{
          marginLeft: "6px",
          fontSize: "13px",
          color: "#128C7E",
          fontWeight: "bold",
          whiteSpace: "nowrap"
        }}
      >
    {t("MailAddrCopied")}
    </span>
  )}

    </footer>
  );
};

export default Footer;
